import React from 'react';
import { Poppins, Spacer } from 'src/common';
import styled from 'styled-components';

const Div = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  grid-gap: 10px;

  .m-sub-title {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.cflowerBlue};
  }
  .m-sub-value {
    font-weight: 500;
  }
`;

interface ModalSubTitleProps {
  title: string;
  value: string;
}

export const ModalSubTitle: React.FC<ModalSubTitleProps> = ({ title, value }) => {
  return (
    <>
      <Spacer $px={4} />
      <Div>
        <Poppins className="m-sub-title">{title}:</Poppins>
        <Poppins className="m-sub-value" px={14} weight={500}>
          {value}
        </Poppins>
      </Div>
    </>
  );
};
